import * as React from 'react';
import { FormControl, InputLabel, Select } from '@mui/material';
export default function SelectInput(props){
    const {
        id,
        label,
        variant,
        value,
        onChange,
        children,
        size = "small",
        align = "left",
        width,
    } = props;
    var labelId = `${id}__LabelId`;
    return <>
        <FormControl fullWidth>
            <InputLabel id={labelId}>{label}</InputLabel>
            <Select
                labelId={labelId}
                id={id}
                value={value}
                variant={variant}
                label={label}
                onChange={onChange}
                size={size}
                align={align}
                width={width}
            >
                {children}
            </Select>
        </FormControl>
    </>
}